<template>
  <div :class="['admin-cell-dialog-text', { empty: value == null }]">
    <v-edit-dialog
      :return-value.sync="theValue"
      v-on="$listeners"
      @save="save"
      @cancel="cancel"
      @open="open"
      large
    >
      <div class="activator-container" :style="containerStyles">
        <div class="activator-text truncate" v-if="!!value">{{
          formattedValue || value
        }}</div>
        <AdminCellEmptyPlaceholder v-else />
      </div>
      <template v-slot:input>
        <slot name="default">
          <v-form v-model="isInputValid">
            <AdminInputPercentage
              :value="theValue"
              @change="theValue = Number($event)"
            />
          </v-form>
        </slot>
      </template>
    </v-edit-dialog>
  </div>
</template>

<script>
import { Model } from '@vuex-orm/core'
import AdminCellEmptyPlaceholder from '@/components/AdminCellEmptyPlaceholder'
import AdminInputPercentage from '@/components/AdminInputPercentage'

export default {
  name: 'AdminCellDialogPercentage',
  components: { AdminCellEmptyPlaceholder, AdminInputPercentage },

  inject: {
    cancel: { default: null },
    open: { default: null },
  },
  props: {
    value: {
      type: [String, Number],
      require: true,
      default: null,
    },
    formattedValue: {
      type: [String, Number],
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    Model: {
      type: Model,
      require: true,
      default: () => Model,
    },
    fieldName: {
      type: String,
      require: true,
    },
    id: {
      type: [String, Number],
      require: true,
    },
  },
  data() {
    return {
      theValue: this.value,
      isInputValid: false,
    }
  },
  computed: {
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        maxWidth,
      }
    }, // containerStyles
  },
  methods: {
    save() {
      if (!this.isInputValid) {
        this.theValue = this.value
        if ('function' === typeof this.cancel) {
          this.cancel()
        }
        return
      }
      if ('function' === typeof this.Model.updateModel) {
        if (this.value == this.theValue) return
        const fields = { [this.fieldName]: this.theValue }
        this.Model.updateModel(this.id, fields)
      }
    }, // save
  },
}
</script>

<style lang="scss">
.activator-container {
  position: relative;
}
.truncate {
  height: auto;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.admin-cell-dialog-text .v-small-dialog__activator__content {
  min-width: 100%;
  width: 100%;
}
</style>
